<div *ngIf="isLoading" class="text-center py-5" role="status" aria-label="Loading booking slots">
  <span class="spinner-border" aria-hidden="true"></span>
</div>
<div class="example-container mat-elevation-z8" [hidden]="isLoading">
    <table mat-table [dataSource]="dataSource">
        <!-- Time Column -->
        <ng-container matColumnDef="dateTime" sticky>
            <th mat-header-cell *matHeaderCellDef class="p-4 day-header" style="background-color: #FFA07A;">
                <b>Day <br /><br /> Time</b>
            </th>
            <td mat-cell *matCellDef="let element" class="date-time-label"
                style="border-bottom: 1px solid #e0e0e0 !important; background-color: #FFA07A;">
                {{getFormattedTime(element.dateTime)}}
            </td>
        </ng-container>

        <!-- Date Columns -->
        <ng-container *ngFor="let column of dayColumnsObj" [matColumnDef]="column.dateFormat">
            <th mat-header-cell *matHeaderCellDef>
                <div class="header-container">
                    <div class="date-header" [ngClass]="getDayClass(column.dateTime)">
                        <div class="date">{{getDayHeader(column.dateTime)}}</div>
                        <div class="weekday">{{getWeekDay(column.dateTime)}}</div>
                    </div>
                    <div class="venues-header">
                        <div *ngFor="let venue of venues" class="venue-tab">
                            {{venue.name}}
                        </div>
                    </div>
                </div>
            </th>
            <td mat-cell *matCellDef="let element" class="slot-cell">
                <div class="venues-container" *ngIf="element[column?.dateFormat]">
                    <div *ngFor="let venue of venues" class="venue-slot"
                        [ngClass]="getSlotClass(element[column.dateFormat][venue.name], column.dateFormat)">
                        <div *ngIf="element && element[column?.dateFormat]?.[venue?.name]" class="slot-content"
                            [ngClass]="getSlotClass(element[column.dateFormat][venue.name],column.dateFormat)"
                            (click)="handleClick($event, element, column.dateFormat, venue.name)"
                            (dblclick)="handleDblClick($event, element, column.dateFormat, venue.name)"
                            [matMenuTriggerFor]="canOpenMenu(element[column.dateFormat][venue.name]) ? slotMenu : null"
                            [matMenuTriggerData]="{ slot: element[column.dateFormat][venue.name] }">
                            <div *ngIf="element[column.dateFormat][venue.name].bookedSlots?.length > 0
                                && !element[column.dateFormat][venue.name].isPartiallyBooked" class="slot-info">
                                <div class="slot-scroll-limiter">
                                    <div *ngFor="let booked of element[column.dateFormat][venue.name].bookedSlots">
                                        <div class="customer-name">{{booked.customerName}}</div>
                                        <div class="price">{{rupeeSign}} {{booked.price}}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- partial & future: remaining slots -->
                            <div *ngIf="element[column.dateFormat][venue.name].isPartiallyBooked
    && !isPastSlot(
         column.dateFormat,
         element[column.dateFormat][venue.name].bookedSlots[0]?.startTime
       )" class="slot-info" style = "font-size: 0.8rem">
                                Last {{ remainingSlots(element[column.dateFormat][venue.name].bookedSlots) }}
                                Slots<br />
                                {{ rupeeSign }}
                                {{ element[column.dateFormat][venue.name].bookedSlots[0].price }}
                            </div>

                            <!-- partial & past: show “Booked by” -->
                            <div *ngIf="element[column.dateFormat][venue.name].isPartiallyBooked
    && isPastSlot(
         column.dateFormat,
         element[column.dateFormat][venue.name].bookedSlots[0]?.startTime
       )" class="slot-info">
                                <div class="customer-name"> {{
                                    element[column.dateFormat][venue.name].bookedSlots[0]?.customerName }}</div>
                                <div class="price">
                                    {{ rupeeSign }} {{ element[column.dateFormat][venue.name].bookedSlots[0]?.price
                                    }}
                                </div>
                            </div>

                            <div *ngIf="element[column.dateFormat][venue.name].availableSlots?.length > 0
            && !element[column.dateFormat][venue.name]?.isPartiallyBooked
            && !element[column.dateFormat][venue.name]?.isBooked" class="slot-info">
                                <div class="price">
                                    {{ rupeeSign }} {{ element[column.dateFormat][venue.name].availableSlots[0]?.price
                                    }}
                                </div>
                            </div>

                            <div *ngIf="!element[column.dateFormat][venue.name].availableSlots?.length &&
                                       !element[column.dateFormat][venue.name].bookedSlots?.length" class="slot-info">
                                {{element[column.dateFormat][venue.name].displayLabel}}
                            </div>
                        </div>

                        <!-- Mat-Menu for Slot Actions -->
                        <mat-menu #slotMenu="matMenu">
                            <div
                                *ngIf="element && element[column?.dateFormat] && element[column?.dateFormat][venue?.name]">
                                <button mat-menu-item
                                    *ngIf="element[column?.dateFormat][venue?.name]?.bookedSlots?.length > 0"
                                    (click)="showDetails(element, column.dateFormat, $event, venue.name)">Show
                                    Details</button>
                                <button mat-menu-item *ngIf="
                                !element[column?.dateFormat][venue?.name]?.isSelected && (element[column?.dateFormat][venue?.name]?.availableSlots?.length > 0 || element[column?.dateFormat][venue?.name]?.isPartiallyBooked)
                                    && element[column?.dateFormat][venue?.name]?.bookedSlots?.length != selectedProduct?.capacityPerVenue
                                    &&  !isPastSlot(
                                        column.dateFormat,
                                        element[column.dateFormat][venue.name].bookedSlots[0]?.startTime
                                      )" (click)="addToCart(element, column.dateFormat, $event, venue.name)">Add to
                                    Cart</button>
                                <button mat-menu-item *ngIf="element[column?.dateFormat][venue?.name]?.isSelected && !isPastSlot(
                                    column.dateFormat,
                                    element[column.dateFormat][venue.name].bookedSlots[0]?.startTime
                                  )" (click)="removeFromCart(element, column.dateFormat, $event, venue.name)">Remove
                                    from
                                    Cart</button>
                            </div>
                        </mat-menu>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnData; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnData;"></tr>
    </table>
</div>
